import {
	EDIT_PAGE_V2,
	EDIT_BLOG_V2,
	VIEW_PAGE,
} from '@confluence/named-routes/entry-points/routes.ts';

import { getDraftShareIdFromCreateContentMetadata } from './draftShareId.ts';
import type { ContentMetadata, ContentBlueprintMetadata } from './ContentMetadata.types.ts';

export const createEditDraftPageUrl = (
	metadata: ContentMetadata | ContentBlueprintMetadata,
): string => {
	const data = 'content' in metadata ? metadata.content : metadata;
	const spaceKey = data?.space?.key;
	const subType = data?.subType;

	if (!spaceKey) {
		return data._links.editui;
	}

	if (subType === 'live') {
		return VIEW_PAGE.toUrl({
			spaceKey,
			contentId: data?.id,
		});
	}

	return EDIT_PAGE_V2.toUrl(
		{
			spaceKey,
			contentId: data?.id,
			contentType: 'pages',
		},
		{
			query: {
				draftShareId: getDraftShareIdFromCreateContentMetadata(data),
			},
		},
	);
};

export const createEditDraftBlogUrl = (metadata: ContentMetadata): string => {
	const spaceAlias = metadata?.space?.alias;
	if (!spaceAlias) {
		return metadata._links.editui;
	}

	return EDIT_BLOG_V2.toUrl(
		{
			spaceKey: spaceAlias,
			contentId: metadata?.id,
			contentType: 'blog',
		},
		{
			query: {
				draftShareId: getDraftShareIdFromCreateContentMetadata(metadata),
			},
		},
	);
};
